module.exports = __webpack_public_path__ + "img/export_xls.2eb22139.png";